




































































































import Editable from '../components/Editable.vue'
import { Watch, Vue, Component } from 'vue-property-decorator';
import vuetifyToast from 'vuetify-toast'
import axios from 'axios'

@Component({
    components: {
        Editable
    }
})
export default class TranslateView extends Vue {
   
    selectedLanguage: string = null;
    phrases: any[] = [];
    show: boolean = true;
    masked: boolean = false;
    saving: boolean = false;
    showOnlyMissingTranslations: boolean = false;

    get visiblePhrases(): any[]{
        if (!this.showOnlyMissingTranslations){
            return this.phrases;
        }
        return this.phrases.filter(p => !p.text || p.text === p.key);
    }

    updatePhrase(event, selectedLanguage, key) {
        // console.log("selectedLanguage: " + selectedLanguage)
        this.$store.state.i18n.translations[selectedLanguage][key] = event;
        this.refreshView();
       
    }
    refreshView(){
        const currentLocale = this.$store.state.i18n.locale;
        const otherLocale = "xx";
        this.$i18n.set(otherLocale)
        this.$i18n.set(currentLocale)
    }
    getText(key) {
        return this.$i18n.translateIn(this.selectedLanguage, key);
    }
    mask(){
        this.masked = !this.masked;
        if (this.masked){
            this.phrases.forEach(p => {
                p.originalText = p.text;
                p.text = "xxxxxx";
                this.$store.state.i18n.translations[this.selectedLanguage][p.key] = p.text;
            })   
        } else {
            this.phrases.forEach(p => {
                p.text = p.originalText;
                if (p.text){
                    this.$store.state.i18n.translations[this.selectedLanguage][p.key] = p.text;
                } else {
                    delete this.$store.state.i18n.translations[this.selectedLanguage][p.key]
                }
            })
        }
        this.refreshView();
    }
    async save() {
        this.saving = true;
        this.updateView();
        const language = {
            code: this.selectedLanguage,
            phrases: this.phrases
        }
        try {
            const translations = this.$store.state.i18n.translations[this.selectedLanguage];
            const response = await axios.post('/locales/' + this.selectedLanguage +  '.json', translations);
            vuetifyToast.success("Translations for " + this.selectedLanguage + " saved");
        } catch (ex){
            console.error(ex);
            vuetifyToast.error("Error saving translations for " + this.selectedLanguage + ". Please check the console.")
        }
        this.saving = false;
    }
    closeTranslateMode(event) {
        this.$store.dispatch("setTranslateMode", false);
    }
    updateView() {
        // console.log("updateView");

        this.selectedLanguage = this.$store.state.i18n.locale;

        if (this.$store.state.i18n.translations[this.selectedLanguage]) {

            const keys = Object.keys(this.$store.state.i18n.translations.en);
            const values = Object.values(this.$store.state.i18n.translations[this.selectedLanguage]);

            this.phrases = [];

            for (const key of keys) {
                this.phrases.push(
                    { 
                        key, 
                        master:  this.$store.state.i18n.translations.en[key],
                        text: this.$store.state.i18n.translations[this.selectedLanguage][key] 
                    }
                );
            }

        }
    }
    rerender() {
        this.show = false
        this.$nextTick(() => {
            this.show = true
            // console.log('re-render start')
            this.$nextTick(() => {
                // console.log('re-render end')
            })
        })
    }
    
    @Watch('$store.state.i18n.locale')
    onLocaleChange(newValue) {
        // console.log("TRANSLATIONS: $store.state.i18n.locale CHANGE DETECTED");
        this.updateView();
        this.rerender();
    }

    @Watch('$store.state.i18n.translations.en')
    onMasterTranslationsChange(newValue) {
        // console.log("TRANSLATIONS: $store.state.i18n.translations.en CHANGE DETECTED");
        this.updateView();
    }

    @Watch('$store.state.missingTranslationCounter')
    onMissingTranslationCounterChange(newValue) {
        // console.log("TRANSLATIONS: $store.state.missingTranslationCounter CHANGE DETECTED");
        this.updateView();
    }

    created() {
        // console.log("TranslateView", "created()");
        this.updateView();
    }
}
